/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
import type * as Types from './graphql.schema-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export * from './graphql.schema-types';
export type MineWallQueryVariables = Exact<{
  date: number;
  offset: number;
  limit: number;
}>;

export type MineWallQuery = {
  getMineWallHistory: Array<{
    author: string | null;
    details: string | null;
    event: Types.UserWallEventType | null;
    time: number | null;
    userEventId: string | null;
  } | null> | null;
};

export const MineWallDocument = gql`
  query mineWall($date: Int!, $offset: Int!, $limit: Int!) {
    getMineWallHistory(date: $date, offset: $offset, limit: $limit) {
      author
      details
      event
      time
      userEventId
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class MineWallGQL extends Apollo.Query<
  MineWallQuery,
  MineWallQueryVariables
> {
  document = MineWallDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
